import axios from 'axios';
import { getDeviceName, setDeviceId } from '../utils';

class UserVisitsService {
  create = async () => {
    const deviceName = getDeviceName();

    const { data } = await axios.post('/user-visits', { deviceName });
    setDeviceId(data.deviceId);
  };
}

export const userVisitsService = new UserVisitsService();
